import consumer from "./consumer"

consumer.subscriptions.create("NotificationsChannel", {
  connected() {
  },

  disconnected() {
  },

  received(data) {
    switch (data.type) {
      // Tools
      case 'merge_sources_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Merge Sources');
        break;
      case 'merge_sources_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'normalise_source_finished':
        toastr.success('Normalise source process has finished.');
        toolsStatus.endToolStatus('Normalise Source');
        break;
      case 'normalise_source_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'build_ranking_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Build Ranking');
        break;
      case 'build_ranking_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'match_keywords_finished':
        var message = 'Match Keywords process has finished.<br/>Total Matched:<br/>' +
                data.total_matched.map(match => {
                  return `- ${match[0]}: ${match[1]}`;
                  }).join("<br/>");
        toastr.success(message);
        toolsStatus.endToolStatus('Match Keywords');
        break;
      case 'match_keywords_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'match_partners_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Match Partners');
        break;
      case 'match_partners_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'match_negative_entities_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Match Negative Entities');
        break;
      case 'match_negative_entities_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'identify_carriers_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Identify Carriers');
        break;
      case 'identify_carriers_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'fetch_alibaba_sellers_ready':
        toastr.success('Fetching Alibaba Sellers has finished');
        $(`#seller_results`).html(data.html);
        break;
      case 'fetch_alibaba_sellers_partial_success':
        toastr.warning(data.message);
        break;
      case 'fetch_alibaba_sellers_retrying':
        toastr.warning(data.message);
        break;
      case 'fetch_alibaba_sellers_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        if (data.html) {
          $(`#seller_results`).html(data.html);
        }
        break;
      case 'fetch_alibaba_sellers_failed':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        if (data.html) {
          $(`#seller_results`).html(data.html);
        }
        break;
        case 'fetch_alibaba_sellers_tracnsactions_finished':
        toastr.success('Fetching Alibaba Sellers Transactions has finished');
      case 'fetch_alibaba_sellers_tracnsaction_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'region_assignment_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Region Assignment');
        break;
      case 'region_assignment_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'exporter_based_in_assignment_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Exporter Based In Assignment');
        break;
      case 'exporter_based_in_assignment_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'check_duplicate_shipments_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Check Duplicate Shipments');
        break;
      case 'check_duplicate_shipments_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      case 'auto_translate_descriptions_finished':
        toastr.success(data.message);
        toolsStatus.endToolStatus('Auto Translate Descriptions');
        break;
      case 'auto_translate_descriptions_error':
        toastr.error(`Errors: ${toolsStatus.messageErrors(data.errors)}`);
        break;
      default:
        console.warn(`Unhandled notification type: ${data.type}`);
    }
  }
});